import { render, staticRenderFns } from "./AutomaticList.vue?vue&type=template&id=205b00d6"
import script from "./AutomaticList.vue?vue&type=script&lang=js"
export * from "./AutomaticList.vue?vue&type=script&lang=js"
import style0 from "./AutomaticList.vue?vue&type=style&index=0&id=205b00d6&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports